import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { companiesApi, Company } from '@/lib/api/companies';

interface CompanyParams {
  limit?: number;
}

export function useCompanies(params?: CompanyParams) {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCompanies = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await companiesApi.getAll({ limit: params?.limit || 100 }); // Get companies for filter
      setCompanies(response.data);
    } catch (err: any) {
      toast.error(err.response?.data?.message || t('companies.fetchError'));
    } finally {
      setIsLoading(false);
    }
  }, [t, params?.limit]);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return {
    companies,
    isLoading,
    refetch: fetchCompanies,
  };
}
